export default {
      id: "sli-switch-usage",
      viewBox: "-1.6 -1.6 19.2 19.2",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-switch",
      toString: function () {
        return this.url;
      }
    }